import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import { NavLink } from 'react-router-dom';
import authService from './api-authorization/AuthorizeService';

interface ReportLists {
    loading: boolean;
    systemCompanyId: number;
    permissions: string[];
}

export class ReportListData extends React.Component<RouteComponentProps<{}>, ReportLists> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            systemCompanyId: 2,
            permissions: []
        }
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=RunReports&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                axios.get('api/User/GetReportPermissionsByUserId?SubId=' + user.sub, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    this.setState({ loading: false, systemCompanyId: res.data.companyId, permissions: res.data.reportPermissions });
                })
                .catch(error => {
                    toast.error(error.message);
                });

            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div>
                <div><h1>Reports</h1></div>
                <div className={this.state.systemCompanyId === 2 && this.state.permissions.indexOf("RunJobKpiReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/jobkpis'} exact activeClassName='active'>
                        Job KPI's
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunItemsOnHireReports") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/itemsonhiresummary'} exact activeClassName='active'>
                        Items on Hire Summary
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunItemsOnHireReports") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/itemsonhire'} exact activeClassName='active'>
                        Items on Hire Currently
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunItemsOnHireReports") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/itemsonhirebydate'} exact activeClassName='active'>
                        Items on Hire / Scheduled By Date
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunPrepaidHireEndingReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/prepaidhireending'} exact activeClassName='active'>
                        Prepaid Customers with Hire Period Ending
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunJobQuoteReports") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/jobquote'} exact activeClassName='active'>
                        Job {this.state.systemCompanyId === 3 ? "Orders" : "Quote"} by Product/Item
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunJobQuoteReports") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/jobquotesummary'} exact activeClassName='active'>
                        Job {this.state.systemCompanyId === 3 ? "Order" : "Quote"} Summary
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 3 && this.state.permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/csrsalessummary'} exact activeClassName='active'>
                        CSR Sales Summary
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/salesbyproduct'} exact activeClassName='active'>
                        Sales by Product
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/salesbybranchsummary'} exact activeClassName='active'>
                        Sales by Branch Summary
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/salesbybranchandproductgroupsummary'} exact activeClassName='active'>
                        Sales by Branch by Product Group Summary
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/jobsummarybyproductgroup'} exact activeClassName='active'>
                        Job Summary by Product Group
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 3 && this.state.permissions.indexOf("RunSalesByProductReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/epajobs'} exact activeClassName='active'>
                        EPA Jobs
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 2 && this.state.permissions.indexOf("RunTruckJobChecksReports") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/truckchecksgrouped'} exact activeClassName='active'>
                        Truck/Tool Checklist
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 2 && this.state.permissions.indexOf("RunTruckJobChecksReports") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/truckchecks'} exact activeClassName='active'>
                        Truck/Tool Checklist (OLD)
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 2 && this.state.permissions.indexOf("RunTruckJobChecksReports") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/jobchecks'} exact activeClassName='active'>
                        Job Checklist
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 2 && this.state.permissions.indexOf("RunCamerasOnHireReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/camerasonhire'} exact activeClassName='active'>
                        Cameras On Hire
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 3 && this.state.permissions.indexOf("RunPowerPolesScheduledReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/powerpolesscheduled'} exact activeClassName='active'>
                        Power Poles Scheduled
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 3 && this.state.permissions.indexOf("RunPowerPolesOnHireReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/powerpolesonhire'} exact activeClassName='active'>
                        Power Poles On Hire
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 3 && this.state.permissions.indexOf("RunFencePickupsReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/fencingpickedup'} exact activeClassName='active'>
                        Fencing Picked Up
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 3 && this.state.permissions.indexOf("RunFencePickupsReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/fencingsummary'} exact activeClassName='active'>
                        Fencing Summary
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunConditionReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/condition'} exact activeClassName='active'>
                        Condition/Dilapidation Report
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 3 && this.state.permissions.indexOf("RunJobsAwaitingPaymentReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/jobsawaitingpayment'} exact activeClassName='active'>
                        Jobs Awaiting Payment
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunInvoicesSentToReckonReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/prepaidinvoicessent'} >
                        Prepaid Invoices Sent To Reckon
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunInvoicesSentToReckonReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/invoicessenttoreckon'} exact activeClassName='active'>
                        Invoices Sent To Reckon
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 3 && this.state.permissions.indexOf("RunEventJobsSummaryReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/eventjobsummary'} exact activeClassName='active'>
                        Event Job Summary
                    </NavLink>
                </div>
                <div className={this.state.systemCompanyId === 2 && this.state.permissions.indexOf("RunCustomerEmailsReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/customeremails'} exact activeClassName='active'>
                        Customer Emails
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunCustomerGateCodesReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/customergatecodes'} exact activeClassName='active'>
                        Customer Gate Codes
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunCustomersLockedReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/customerslocked'} exact activeClassName='active'>
                        Customers Locked
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunCustomerGateCodesReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/customerspricelist'} exact activeClassName='active'>
                        Customers by Pricelist
                    </NavLink>
                </div>
                <div className={this.state.permissions.indexOf("RunDeletedJobsReport") > 0 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/reports/deletedjobs'} exact activeClassName='active'>
                        Deleted Jobs
                    </NavLink>
                </div>
            </div>
        );

    }

};